import { Injectable } from '@angular/core';
import {
  ModalEventType,
  ModalComponent,
  ModalOptions,
  ModalSize,
  Modal,
  ModalResult,
} from '@shared/components/modal/modal.component';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private modalComponent?: ModalComponent;

  register(modal: ModalComponent) {
    this.modalComponent = modal;
  }

  open(
    options: ModalOptions = {},
    content?: Modal['content']
  ): Observable<ModalResult> {
    if (!this.modalComponent) {
      throw new Error('ModalComponent is not registered.');
    }
    const defaultOptions: ModalOptions = {
      size: ModalSize.MEDIUM,
      confirmationLabel: 'Submeter',
      confirmationDisabled: false,
      cancellationLabel: 'Cancelar',
      hasConfirmation: true,
      hasCancellation: true,
      animationDelay: 200,
      enableScroll: true,
      closeOnCancellation: true,
      closeOnConfirmation: true,
      style: 'modal',
      variant: 'gray',
    };
    return this.modalComponent.open(content, { ...defaultOptions, ...options });
  }

  closeAll() {
    this.modalComponent?.closeAll();
  }

  close(id: ModalOptions['id'], event = ModalEventType.CLOSED) {
    const modal = this.modalComponent?.modals.find(
      (modal) => modal.options.id === id
    );
    if (modal) {
      modal.options.isOpen = false;
      this.modalComponent?.close(modal, event);
    }
  }
}
